import { render, staticRenderFns } from "./preventBid.vue?vue&type=template&id=2f7fd6fc&scoped=true"
import script from "./preventBid.vue?vue&type=script&lang=js"
export * from "./preventBid.vue?vue&type=script&lang=js"
import style0 from "./preventBid.vue?vue&type=style&index=0&id=2f7fd6fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7fd6fc",
  null
  
)

export default component.exports